<div odxLayout="flex gap-none" class="flex-column h-100 overflow-hidden product-list-wrapper">
  <odx-area-header class="product-header">
    <h5 class="odx-title-5" i18n="@@monitoring.productList.header" data-testid="monitoring.productList.header">Produktliste</h5>
    <odx-area-header-content>
      @if (canEditAdditionalProducts()) {
        <app-monitoring-product-list-search [project]="project"></app-monitoring-product-list-search>
      }
    </odx-area-header-content>
  </odx-area-header>

  <div odxLayout="grid gap-none" class="h-100 overflow-hidden product-list-grid">
    @if (productListDataInitialized) {
      <div odxLayout="12 7@tablet" class="container h-100 right-border scroll products-column">
        <odx-accordion [multiple]="true" class="bottom-border">
          <odx-accordion-item
            data-testid="productList.productsOnFloorPlan"
            [expanded]="productsOnFloorPlanExpanded"
            (expandedChange)="productsOnFloorPlanExpanded = $event"
          >
            <odx-accordion-item-title odxLayout="flex" class="space-between">
              <span i18n="@@productList.productsOnFloorPlan">Produkte auf dem Grundrissplan</span>
            </odx-accordion-item-title>
            @for (group of placedGroupDisplayData; track group.key) {
              <odx-accordion-item
                data-testid="productList.groupSection"
                [expanded]="getGroupExpanded(group.key)"
                (expandedChange)="setGroupExpanded(group.key, $event)"
              >
                <odx-accordion-item-title odxLayout="flex" class="space-between">
                  <span>{{ group.label }}</span>
                </odx-accordion-item-title>
                @for (section of group.sections; track section.key) {
                  <odx-accordion-item
                    [expanded]="getProductSectionExpanded(group.key, section.key)"
                    (expandedChange)="setProductSectionExpanded(group.key, section.key, $event)"
                  >
                    <odx-accordion-item-title odxLayout="flex" class="space-between">
                      <span>{{ section.label }}</span>
                    </odx-accordion-item-title>
                    <app-monitoring-product-table [productSection]="$any(section.section)"></app-monitoring-product-table>
                  </odx-accordion-item>
                }
              </odx-accordion-item>
            }
          </odx-accordion-item>

          @if (additionalSections.length > 0) {
            <odx-accordion-item
              class="additional-products-accordion-item"
              [expanded]="additionalProductsExpanded"
              (expandedChange)="additionalProductsExpanded = $event"
            >
              <odx-accordion-item-title class="additional-products-header-title">
                <div class="additional-products-header-row">
                  <div class="additional-products-header-main">
                    <span>{{ additionalProductsLabel }}</span>
                  </div>
                  <div class="additional-products-header-right">
                    @if (canEditAdditionalProducts()) {
                      <button
                        odxButton
                        [variant]="editAdditionalProducts ? 'primary' : 'secondary'"
                        type="button"
                        class="additional-products-action"
                        [class.additional-products-action--edit]="!editAdditionalProducts"
                        (click)="$event.stopPropagation(); toggleAdditionalProductsEditMode()"
                      >
                        <span class="additional-products-action__content">
                          <odx-icon
                            [name]="editAdditionalProducts ? 'save' : 'edit'"
                            size="medium"
                            class="additional-products-action__icon"
                          ></odx-icon>
                          <span class="additional-products-action__label">
                            {{ editAdditionalProducts ? saveAdditionalProductsLabel : editAdditionalProductsLabel }}
                          </span>
                        </span>
                      </button>
                    }
                  </div>
                </div>
              </odx-accordion-item-title>
              @for (group of additionalCategoryDisplayData; track group.key) {
                <odx-accordion-item
                  class="additional-products-category-item"
                  [expanded]="getAdditionalCategoryExpanded(group.key)"
                  (expandedChange)="setAdditionalCategoryExpanded(group.key, $event)"
                >
                  <odx-accordion-item-title odxLayout="flex" class="space-between">
                    <span>{{ group.label }}</span>
                  </odx-accordion-item-title>
                  <app-monitoring-additional-products-table
                    [configs]="group.configs"
                    [editMode]="editAdditionalProducts"
                    [draftQuantities]="additionalProductDrafts"
                    [emptyMessage]="getAdditionalProductsEmptyMessage(group.label)"
                    (quantityStep)="updateAdditionalProductQuantity($event.configId, $event.delta)"
                    (quantityChange)="setAdditionalProductQuantity($event.configId, $event.value)"
                    (remove)="removeAdditionalProduct($event)"
                  ></app-monitoring-additional-products-table>
                </odx-accordion-item>
              }
            </odx-accordion-item>
          }

          @if (serviceRows.length > 0) {
            <odx-accordion-item [expanded]="servicesExpanded" (expandedChange)="servicesExpanded = $event">
              <odx-accordion-item-title odxLayout="flex" class="space-between">
                <p i18n="@@global.services" data-testid="monitoring.productList.services">Dienstleistungen</p>
              </odx-accordion-item-title>
              <div class="table-scroll-wrapper">
                <table class="navinta-table">
                  <thead>
                    <tr>
                      <th
                        i18n="@@monitoring.productList.servicesTable.position.header"
                        data-testid="monitoring.productList.servicesTable.column1"
                      >
                        Pos.
                      </th>
                      <th
                        i18n="@@monitoring.productList.servicesTable.description.header"
                        data-testid="monitoring.productList.servicesTable.column2"
                      >
                        Bezeichnung
                      </th>
                      <th
                        i18n="@@monitoring.productList.servicesTable.materialNumber.header"
                        data-testid="monitoring.productList.servicesTable.column3"
                      >
                        Material Nummer
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (serviceRow of serviceRows; track serviceRow.id) {
                      <tr>
                        <td>{{ serviceRow.position }}</td>
                        <td>{{ serviceRow.name }}</td>
                        <td>{{ serviceRow.partNumber }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </odx-accordion-item>
          }
        </odx-accordion>
      </div>
    }

    <div odxLayout="12 5@tablet" class="container h-100 overflow-hidden services-column">
      <h6 class="odx-subtitle-6" i18n="@@global.services" data-testid="monitoring.productList.headerServices">
        Dienstleistungen
      </h6>
      <app-services-editor
        [form]="servicesForm"
        [services]="serviceEditorEntries"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
      ></app-services-editor>
    </div>
  </div>
</div>
